export enum FeedbackButtonKey {
  SendMail = 'send-mail',
  ResendMail = 'resend-mail',
}
